import { render } from "./B2bTableLinesRemadv.vue?vue&type=template&id=5e361c88&scoped=true&lang=pug"
import script from "./B2bTableLinesRemadv.vue?vue&type=script&lang=js"
export * from "./B2bTableLinesRemadv.vue?vue&type=script&lang=js"

import "./B2bTableLinesRemadv.vue?vue&type=style&index=0&id=5e361c88&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e361c88"]])

export default __exports__